/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2019, Zumper
 * @description Photo Carousel Right Chevron Component
 */

import { IconProps } from '../../types'

export const ChevronRight = ({ fill = '#0a0f1c', size = 10, ...rest }: IconProps) => {
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 37 37"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.9648 34.6401L34.6396 17.9653L18.6744 2.00009"
        stroke={fill}
        strokeLinecap="round"
        strokeWidth="5"
      />
    </svg>
  )
}
